import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconKarte = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M18.6662 5.33239C20.1387 5.33239 21.3324 4.13869 21.3324 2.66619C21.3324 1.1937 20.1387 0 18.6662 0C17.1937 0 16 1.1937 16 2.66619C16 4.13869 17.1937 5.33239 18.6662 5.33239Z",
			fill: "#354341"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M20.1542 11.8297C18.5823 10.277 16.0336 10.277 14.4616 11.8297L9.82227 16.411L14.3016 20.8343C16.4449 20.2423 18.4683 19.1163 20.1542 17.451C21.7262 15.899 21.7262 13.3823 20.1542 11.8297Z",
			fill: "#A9DDD8"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.66619 5.33239C4.13869 5.33239 5.33239 4.13869 5.33239 2.66619C5.33239 1.1937 4.13869 0 2.66619 0C1.1937 0 0 1.1937 0 2.66619C0 4.13869 1.1937 5.33239 2.66619 5.33239Z",
			fill: "#354341"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.511 16.4123L6.87165 11.831C5.29966 10.279 2.751 10.279 1.179 11.831C-0.392999 13.3837 -0.392999 15.9003 1.179 17.4523C2.865 19.1176 4.88899 20.2436 7.03165 20.8356L11.511 16.4123Z",
			fill: "#54BBB2"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.77148 20.424C5.79748 20.434 5.82348 20.4446 5.84948 20.4546C6.08748 20.5446 6.32748 20.6273 6.56882 20.7033C6.63815 20.7253 6.70748 20.7473 6.77748 20.768C7.00748 20.8366 7.23948 20.898 7.47215 20.9546C7.55748 20.9746 7.64215 20.9953 7.72748 21.014C7.94481 21.062 8.16281 21.1033 8.38148 21.1406C8.48681 21.1586 8.59148 21.176 8.69748 21.1913C8.89548 21.2206 9.09414 21.244 9.29348 21.264C9.42214 21.2766 9.55081 21.2886 9.67948 21.298C9.85548 21.3113 10.0321 21.3193 10.2081 21.3253C10.3608 21.33 10.5141 21.334 10.6668 21.334C10.8195 21.334 10.9721 21.33 11.1248 21.3253C11.3015 21.3193 11.4781 21.3113 11.6541 21.298C11.7828 21.2886 11.9115 21.2766 12.0401 21.264C12.2388 21.244 12.4381 21.2206 12.6361 21.1913C12.7415 21.176 12.8468 21.1586 12.9521 21.1406C13.1708 21.1033 13.3888 21.062 13.6055 21.014C13.6908 20.9953 13.7761 20.9746 13.8608 20.9546C14.0941 20.898 14.3261 20.8366 14.5561 20.768C14.6261 20.7473 14.6955 20.7253 14.7648 20.7033C15.0061 20.6273 15.2461 20.5446 15.4835 20.4546C15.5101 20.4446 15.5361 20.434 15.5621 20.424L10.6668 15.59L5.77148 20.424Z",
			fill: "#2AAB9F"
		})
	]
});
export default SvgIconKarte;
